module.exports = __webpack_public_path__ + "media/pohadka-1.0754a45a.mp3";